/** 分类接口。 */
import { http } from '@/utils/request'
import type {
  CategoryCreate,
  CategoryDetail,
  CategoryListItem,
  CategoryUpdate
} from '@/types/category'
import type { ApiMessage, CreateResult } from '@/types/common'

export function getCategories(params?: { include_inactive?: boolean }): Promise<CategoryListItem[]> {
  return http.get<CategoryListItem[]>('/categories', { params })
}

export function getCategory(id: number): Promise<CategoryDetail> {
  return http.get<CategoryDetail>(`/categories/${id}`)
}

export function createCategory(payload: CategoryCreate): Promise<CreateResult> {
  return http.post<CreateResult>('/categories', payload)
}

export function updateCategory(id: number, payload: CategoryUpdate): Promise<ApiMessage> {
  return http.put<ApiMessage>(`/categories/${id}`, payload)
}

export function deleteCategory(id: number): Promise<ApiMessage> {
  return http.delete<ApiMessage>(`/categories/${id}`)
}

export function updateCategoriesOrder(ids: number[]): Promise<ApiMessage> {
  return http.put<ApiMessage>('/categories/sort', { ids })
}
